module.exports = require('./helpers/bundle-url').getBundleURL('j8FQO') + "logo.c51670a8.svg";